import { takeLatest, put } from 'redux-saga/effects';
import moment from 'moment';

import { storage } from '@commons/storage';

import {
  CONFIG_SESSION,
  outrasSaidaAnimal,
  NEW_OUTRAS_SAIDA_ANIMAL,
  NEW_OUTRAS_SAIDA_ANIMAL_SUCCESS,
} from '@handler';

function* sagaNewOutrasSaidaAnimal(action) {

  yield put({ type: NEW_OUTRAS_SAIDA_ANIMAL_SUCCESS, registro: 
    {
      ...outrasSaidaAnimal.newRegistro,
      data: moment().startOf('day').format('YYYY-MM-DD'),
      anoPecuario: JSON.parse(storage.get(CONFIG_SESSION)).anoPecuarioAtivo,
    } });
}

export default function* watchNewOutrasSaidaAnimal() {
  yield takeLatest(NEW_OUTRAS_SAIDA_ANIMAL, sagaNewOutrasSaidaAnimal)
}
